export default __webpack_public_path__ + "static/media/Honey 9781843628217.28941661.jpg";